import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getChatSessions } from "../../services/clients";
import ChatSessionsTable from "../../components/Tables/ChatSessionsTable";

export const ChatSessions = () => {
  const { selectedClient } = useContext(AppContext);
  const [chatSessions, setChatSessions] = useState([]);

  useEffect(() => {
    const fetchChatSessions = async () => {
      try {
        setChatSessions(
          await getChatSessions(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchChatSessions();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <ChatSessionsTable chatSessions={chatSessions} />
    </div>
  );
};

export default ChatSessions;
